import React from 'react';

import { fetchCalendarCategories } from '../../../../../api/calendarApi';
import { mapActiveCategories, mergeCheckedCategories } from '../newCalendar.helpers';

export function useCalendarCategories(token, initialCategoryChecks = {}) {
  const [categories, setCategories] = React.useState([]);
  const [categoryChecks, setCategoryChecks] = React.useState(() => (
    initialCategoryChecks && typeof initialCategoryChecks === 'object' ? initialCategoryChecks : {}
  ));

  React.useEffect(() => {
    if (!token) return undefined;

    let isActive = true;

    const loadCategories = async () => {
      try {
        const response = await fetchCalendarCategories(token);
        if (!isActive) return;

        const rows = Array.isArray(response?.data) ? response.data : [];
        const activeCategories = mapActiveCategories(rows);
        setCategories(activeCategories);
        setCategoryChecks((current) => mergeCheckedCategories(current, activeCategories));
      } catch (_error) {
        if (isActive) setCategories([]);
      }
    };

    loadCategories();
    return () => { isActive = false; };
  }, [token]);

  const setCategoryChecked = React.useCallback((categoryId, checked) => {
    setCategoryChecks((current) => ({ ...current, [categoryId]: checked }));
  }, []);

  return { categories, categoryChecks, setCategoryChecked };
}
